import { cn } from "@/lib/utils";

interface AnimatedUnderlineProps {
  isVisible: boolean;
  className?: string;
  color?: "primary" | "foreground";
}

export function AnimatedUnderline({ isVisible, className, color = "primary" }: AnimatedUnderlineProps) {
  return (
    <span
      className={cn(
        "block h-[3px] rounded-full mt-2 origin-left transition-transform duration-700 ease-out",
        color === "primary" ? "bg-primary" : "bg-foreground",
        isVisible ? "scale-x-100" : "scale-x-0",
        className
      )}
    />
  );
}
